import React from 'react';

export const uploadDescription = () => (
  <div>
    <h3 className="vads-u-font-size--h5">Supporting documents</h3>
    <p>
      Some examples of other documents that could help support your claim
      include:
    </p>
    <ul>
      <li>
        A copy of a DD-2911 (DoD Sexual Assault Forensic Examination (SAFE)
        Report)
      </li>
      <li>Military or civilian police reports that you haven’t yet uploaded</li>
      <li>
        Supporting statements from roommates, family members, clergy, or fellow
        service members
      </li>
      <li>Your personal journals or diaries</li>
      <li>
        Performance evaluations, a divorce decree, before-and-after photos
        showing a physical change
      </li>
    </ul>
  </div>
);
